import { CrudService } from "../services/crud.service";
import { message } from "../shared/message";

const initialState = {
  data: {},
  item: {}
};

const resource = "dashboard-widget-item";

export const dashboardWidgetItem = {
  namespaced: true,
  state: initialState,
  actions: {
    getDashboardWidgetItemList({ commit, rootState }) {
      CrudService.of(`${resource}`).getList(rootState.common.pagination, rootState.common.searchQuery).then(data => {
        commit("loadDashboardWidgetItemList", data);
        commit("common/setTotalItems", data.totalElements, { root: true });
      });
    },
    getDashboardWidgetItem({ commit }, id) {
      CrudService.of(`${resource}`).getItem(id).then(item => {
        commit("loadDashboardWidgetItem", item);
      });
    },
    createDashboardWidgetItem(context, dashboardWidget) {
      CrudService.of(`${resource}`).createItem( dashboardWidget).then(() =>
          message.success("Create Dashboard Widget Success!", "/dashboard-widget-item/list"));
    },
    updateDashboardWidgetItem(context, dashboardWidget) {
      CrudService.of(`${resource}`).updateItem(dashboardWidget).then(() =>
          message.success("Update Dashboard Widget Success!", "/dashboard-widget-item/list"));
    },
    deleteDashboardWidgetItem({ dispatch }, id) {
      CrudService.of(`${resource}`).deleteItem(id).then(() => {
        dispatch("getDashboardWidgetItemList");
      });
    }
  },
  mutations: {
    loadDashboardWidgetItemList(state, data) {
      state.data = data;
    },
    loadDashboardWidgetItem(state, item) {
      state.item = item;
    }
  }
};
